export default {
  mensajes: {
    inicial: 'Hallo!',
    descripcion: 'In nur drei  Schritten,erhälst Du hier schnell und einfach Dein Angebot.',
    resumen: 'Angebot ansehen',
    cuestionario: {
        titulo: 'Erzählen Sie uns von Ihrer Erfahrung',
        introduccion: 'Ihre Meinung hilft uns, die Qualität aller Leistungen Ihrer Reise zu verbessern.',
        cargando: 'Ihr Fragebogen wird vorbereitet…',
        enlace_invalido: 'Dieser Link gehört zu keiner Buchung.',
        error_carga: 'Der Fragebogen konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
        error_envio: 'Ihre Antworten konnten nicht gesendet werden. Bitte versuchen Sie es erneut.',
        no_disponible: 'Der Fragebogen ist nach Abschluss Ihrer Reise verfügbar.',
        disponible_desde: 'Sie können ihn ab dem {fecha} ausfüllen.',
        sin_preguntas: 'Für die Leistungen dieser Buchung sind keine Fragen verfügbar.',
        gracias: 'Vielen Dank, dass Sie Ihre Erfahrung mit uns teilen!',
        enviado_correctamente: 'Ihre Antworten wurden erfolgreich gespeichert.',
        bloques_guardados: '1 Bewertung wurde gespeichert. Sie können die restlichen noch ausfüllen. | {count} Bewertungen wurden gespeichert. Sie können die restlichen noch ausfüllen.',
        comentario: 'Möchten Sie uns noch etwas mitteilen? (optional)',
        de_diez: 'von 10',
        enviar: 'Antworten senden',
        responde_una: 'Beantworten Sie mindestens eine Frage, bevor Sie senden.',
        secciones: {
          rutas_meigas: 'Rutas Meigas',
          alojamientos: 'Unterkünfte',
          servicios: 'Leistungen',
        },
        tipos: {
          general: 'Rutas Meigas',
          alojamiento: 'Unterkunft',
          servicio: 'Leistung',
        },
    },
    login: {
      agencias: 'AGENTUREN',
      trabaja_con_nosotros: 'Möchten Sie als Agentur mit uns zusammenarbeiten?',
      descripcion_registro: 'Hinterlassen Sie uns Ihre Daten und wir kontaktieren Sie, um Ihre Agentur anzumelden.',
      contactar: 'Kontakt aufnehmen',
      agencia_requerida: 'Agentur (*)',
      responsable_requerido: 'Ansprechpartner/in (*)',
      email_requerido: 'E-Mail (*)',
      telefono_requerido: 'Telefonnummer (*)',
      mensaje_opcional: 'Nachricht (optional)',
      solicitud_enviada: 'Ihre Anfrage wurde erfolgreich gesendet. Wir werden Sie in Kürze kontaktieren. Vielen Dank für Ihr Interesse.',
      enviando: 'Wird gesendet...',
      enviar_solicitud: 'Anfrage senden',
      agencia_registrada: 'Sind Sie bereits als Agentur registriert?',
      accede_con_tus_datos: 'Melden Sie sich mit Ihren Daten an',
      nombre: 'Name',
      contrasena: 'Passwort',
      accediendo: 'Anmeldung läuft...',
      acceder: 'Anmelden',
      error_campos_obligatorios: 'Bitte füllen Sie Agentur, Ansprechpartner/in, E-Mail und Telefonnummer aus.',
      error_email_invalido: 'Die E-Mail-Adresse ist ungültig.',
      error_solicitud: 'Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    },
    central_reservas: {
      nueva_solicitud: 'Neue Anfrage',
      expedientes_menu: 'Buchungen',
      expedientes: 'Buchungen',
      proformas: 'Proformas',
      invoices_menu: 'Rechnungen',
      perfil_agencia: 'Agenturprofil',
      ayuda: 'Hilfe',
      cerrar_sesion: 'Abmelden',
      selecciona_camino: 'Wählen Sie einen Jakobsweg',
      selecciona_agencia_origen: 'Wählen Sie die Herkunftsagentur',
      idioma_documentacion: 'Sprache der Buchungsunterlagen',
      idioma_es: 'Spanisch',
      idioma_en: 'Englisch',
      idioma_de: 'Deutsch',
      cambiar_idioma: 'Sprache ändern',
      nombre_agencia: 'Name der Agentur',
      telefono_agencia: 'Telefonnummer der Agentur',
      email_agencia: 'E-Mail der Agentur',
      instrucciones_cliente: 'Bitte geben Sie unten die Daten Ihres Kunden ein.\n\nWenn Sie das Angebot anfordern, wird es sowohl an die E-Mail-Adresse der Agentur als auch an die E-Mail-Adresse des Kunden gesendet.',
      instrucciones_cliente_pendientes: 'Wenn Sie das Angebot anfordern, wird es an die E-Mail-Adresse der Agentur gesendet. Das Rutas-Team wird Ihnen das vollständige Angebot mit den noch zu kalkulierenden Leistungen so schnell wie möglich zusenden.\n\nBitte geben Sie unten die Daten Ihres Kunden ein.',
      nombre_cliente: 'Vorname des Kunden',
      apellidos_cliente: 'Nachname des Kunden',
      email_cliente: 'E-Mail des Kunden',
      aviso_cliente_servicios_pendientes: '*Bitte beachten Sie, dass der Kunde keine Kopie dieser Anfrage erhält, da zusätzliche Leistungen noch kalkuliert werden müssen.',
      enviar_propuesta_cliente: 'Angebot an den Kunden senden',
      recibir_propuesta: 'Angebot erhalten',
      expedientes: {
        refrescar: 'Aktualisieren',
        reservas_por_pagina: 'Buchungen pro Seite',
        codigo: 'Code',
        referencia_agencia: 'Agentur-Ref.',
        fecha_inicio: 'Startdatum',
        fechas_camino: 'Reisedaten',
        estado: 'Status',
        cliente: 'Kunde',
        cliente_camino: 'Kunde / Jakobsweg',
        solicitud: 'Anfrage',
        peregrinos: 'Pilger/innen',
        peregrinos_corto: 'Pax',
        habitaciones: 'Zimmer',
        habitaciones_corto: 'Zi.',
        ver_detalle: 'Details anzeigen',
        sin_datos: 'Keine Daten verfügbar',
        cargando_detalle: 'Buchungsdetails werden geladen...',
        detalle_reserva: 'Buchungsdetails',
        ver_historial: 'Verlauf anzeigen',
        agente_asignado: 'Zugewiesene/r Mitarbeiter/in',
        agente: 'Mitarbeiter/in',
        codigo_interno: 'Interner Code',
        inicio: 'Beginn',
        llegada: 'Ankunft',
        idioma: 'Sprache',
        editar: 'Bearbeiten',
        cancelar: 'Abbrechen',
        guardar: 'Speichern',
        cliente_actualizado: 'Kundendaten wurden erfolgreich aktualisiert.',
        importe_reserva_pvp: 'Buchungsbetrag (UVP)',
        comision_agencia: '15% Agenturprovision',
        importe_neto_agencia: 'Netto-Agenturbetrag',
        servicios_agregados_neto: 'Zusatzleistungen (Netto)',
        importe_total_pvp: 'Gesamtbetrag (UVP)',
        importe_total_neto: 'Gesamtbetrag (Netto)',
        pasajeros: 'Reisende',
        modificar_pasajeros: 'Reisende bearbeiten',
        sin_pasajeros: 'Für diese Buchung sind keine Reisenden registriert',
        archivos_reserva: 'Buchungsdokumente',
        archivos_seleccionados: '0 ausgewählt | 1 ausgewählt | {count} ausgewählt',
        enviar_archivos: 'Dateien senden',
        fecha: 'Datum',
        documento: 'Dokument',
        nombre: 'Name',
        tipo_documento: 'Dokumenttyp',
        numero_documento: 'Dokument-Nr.',
        movil: 'Mobil',
        ver: 'Anzeigen',
        enviar: 'Senden',
        enviar_cliente: 'An Kunden senden',
        solicitar_modificacion: 'Änderung anfordern',
        solicitar_confirmacion: 'Bestätigung anfordern',
        sin_archivos: 'In diesem Bereich sind keine Dateien vorhanden',
        error_cargar_detalle: 'Die Buchungsdetails konnten nicht geladen werden.',
        correo_enviado: 'E-Mail wurde erfolgreich gesendet.',
        documentos_seleccionados: 'Ausgewählte Dokumente',
        para: 'An',
        asunto: 'Betreff',
        texto_correo: 'E-Mail-Text',
        mensaje_agencia: 'Nachricht an die Agentur',
        detalle_correo: 'E-Mail-Details',
        documentos_adjuntos: 'Angehängte Dokumente',
        historial_reserva: 'Buchungsverlauf',
        usuario: 'Benutzer/in',
        descripcion: 'Beschreibung',
        mensaje: 'Nachricht',
        adjunto: 'Anhang',
        sin_estado: 'KEIN STATUS',
        historial_agencia_rutas: 'Verlauf {agencia} <=> Rutas Meigas',
        historial_agencia_cliente: 'Verlauf {agencia} <=> Kunde',
        ver_documento: 'Dokument anzeigen',
        sin_acciones_historial: 'Im Verlauf sind keine Aktionen vorhanden',
      },
      invoices: {
        titulo: 'Rechnungen',
        descripcion: 'Liste der für die Agentur ausgestellten Rechnungen.',
        registros: '0 Einträge | 1 Eintrag | {count} Einträge',
        sin_facturas: 'Für diese Agentur sind keine Rechnungen verfügbar.',
        filtrar_fecha: 'Nach Datum filtern',
        filtrar_expediente: 'Nach Buchung filtern',
        filtrar_documento: 'Nach Dokument filtern',
        fecha: 'Datum',
        expediente: 'Buchung',
        tipo: 'Typ',
        factura: 'RECHNUNG',
        ver: 'Anzeigen',
        error_agencia: 'Die Agentur konnte zum Laden der Rechnungen nicht identifiziert werden.',
        error_carga: 'Die Rechnungen konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
      },
      perfil: {
        titulo: 'Agenturprofil', descripcion: 'Informationen zur Agentur des angemeldeten Benutzers.', agencia_activa: 'Aktive Agentur', refrescar: 'Aktualisieren', guardar: 'Speichern', sin_agencia: 'Das Profil kann ohne Identifizierung der Agentur nicht gespeichert werden.', aviso_completar: 'Alle Daten des Agenturprofils müssen vor dem Fortfahren ausgefüllt werden.', cambiar_logo: 'Logo ändern', campo_obligatorio: 'Pflichtfeld', comision: 'Provision', datos_generales: 'Allgemeine Daten', nombre: 'Name', responsable: 'Ansprechpartner/in', telefono_2: 'Telefonnummer 2', direccion: 'Adresse', codigo_postal: 'Postleitzahl', poblacion: 'Ort', provincia: 'Provinz', pais: 'Land', datos_fiscales: 'Steuerdaten', nombre_fiscal: 'Firmenname', direccion_fiscal: 'Geschäftsadresse', codigo_postal_fiscal: 'Geschäftliche Postleitzahl', poblacion_fiscal: 'Geschäftsort', provincia_fiscal: 'Geschäftsprovinz', pais_fiscal: 'Geschäftsland', usuarios_asociados: 'Zugeordnete Benutzer', sin_usuarios: 'Es sind keine Benutzer zugeordnet.', caminos_permitidos: 'Zugelassene Jakobswege', camino: 'Jakobsweg', sin_caminos: 'Es sind keine Jakobswege zugeordnet.', error_refrescar: 'Das Agenturprofil konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.', exito_guardar: 'Agenturprofil wurde erfolgreich gespeichert.', error_guardar: 'Das Agenturprofil konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.', error_imagen_invalida: 'Die ausgewählte Datei ist kein gültiges Bild.', error_procesar_imagen: 'Das ausgewählte Bild konnte nicht verarbeitet werden.'
      },
      ayuda_contenido: {
        titulo: 'Hilfezentrum', descripcion: 'Finden Sie schnelle Antworten nach Thema oder durchsuchen Sie häufig gestellte Fragen.', buscar: 'Hilfe durchsuchen', temas: 'Hilfethemen', preguntas: '0 Fragen | 1 Frage | {count} Fragen', mas_ayuda: 'Benötigen Sie weitere Hilfe?', contacto: 'Wenn Sie keine Antwort finden, können Sie uns unter dieser E-Mail-Adresse kontaktieren.', general: 'Allgemein', general_descripcion: 'Allgemeine Informationen zur Funktionsweise der Anwendung.', solicitudes: 'Neue Anfrage', solicitudes_descripcion: 'Erstellung von Buchungen, Daten, Zimmern und Preisen.', expedientes: 'Buchungen', expedientes_descripcion: 'Suche, Filter und Status bestehender Buchungen.', cuenta: 'Konto und Zugang', cuenta_descripcion: 'Anmeldung, Agenturprofil und Sicherheit.', video_tutorial: 'Videoanleitung', video_ayuda: 'Hilfevideo', preguntas_frecuentes: 'Häufig gestellte Fragen', sin_resultados: 'Für die ausgewählten Filter wurden keine Fragen gefunden.',
        faqs: {
          general: {
            1: { pregunta: 'Welche Module umfasst das Buchungszentrum?', respuesta: '<p>Die Anwendung ist in Module wie Hilfe, neue Anfrage, Buchungen und Konto/Zugang gegliedert.</p><p>Jedes Modul bündelt konkrete Funktionen für die tägliche Arbeit.</p>' },
            2: { pregunta: 'Wie finde ich schnell eine Funktion in der Anwendung?', respuesta: '<p>Verwenden Sie das Seitenmenü, um zwischen den Modulen zu wechseln.</p><p>Im Hilfezentrum finden Sie Videos und häufig gestellte Fragen zu jedem Bereich.</p>' },
            3: { pregunta: 'Was kann ich tun, wenn eine Liste oder ein Formular nicht die erwarteten Informationen anzeigt?', respuesta: '<p>Prüfen Sie zunächst:</p><ul><li>Aktive Filter</li><li>Aktuelle Seite</li><li>Ausstehende Pflichtfelder</li></ul><p>Wenn das Problem weiterhin besteht, wenden Sie sich an den Support und geben Sie Agentur, Modul und Fehlerkontext an.</p>' }
          },
          solicitudes: {
            1: { pregunta: 'Welche Felder sind zum Erstellen einer Anfrage erforderlich?', respuesta: '<p>Sie müssen Jakobsweg, Sprache, Datum, Zimmer, Pilger/innen und das Feld <strong>Buchungscode der Agentur</strong> ausfüllen.</p>' },
            2: { pregunta: 'Wann werden die Preise neu berechnet?', respuesta: '<p>Die Preise werden automatisch neu berechnet, wenn Sie Folgendes ändern:</p><ul><li>Jakobsweg</li><li>Daten</li><li>Anzahl der Zimmer</li></ul>' },
            3: { pregunta: 'Warum kann ich nicht zum nächsten Schritt weitergehen?', respuesta: '<p>Dies liegt normalerweise an einem der folgenden Gründe:</p><ul><li>Ein Pflichtfeld fehlt</li><li>Es gibt keine gültige Verteilung von Zimmern und Pilger/innen</li></ul>' },
            4: { pregunta: 'Wie verteile ich die Anzahl der Zimmer korrekt?', respuesta: '<p>Die Summe der Zimmer muss mit der Anzahl der Pilger/innen übereinstimmen.</p><p>Wenn die Verteilung nicht passt, können Sie nicht mit dem nächsten Schritt fortfahren.</p>' },
            5: { pregunta: 'Kann ich eine Anfrage vor dem Senden bearbeiten?', respuesta: '<p>Ja. Solange Sie den letzten Schritt nicht bestätigen, können Sie:</p><ul><li>Zurückgehen</li><li>Daten ändern</li><li>Zimmer ändern</li><li>Kundendaten aktualisieren</li></ul>' },
            6: { pregunta: 'Was passiert, wenn keine Verfügbarkeit oder kein Preis angezeigt wird?', respuesta: '<p>Dies liegt meist an einer ungültigen Kombination von Daten, Belegung oder Leistungen.</p><p>Prüfen Sie vor einem erneuten Versuch den Jakobsweg, die Sprache und die Zimmerverteilung.</p>' }
          },
          expedientes: {
            1: { pregunta: 'Welche Filter kann ich bei Buchungen verwenden?', respuesta: '<p>Sie können filtern nach:</p><ul><li>Code</li><li>Agenturcode</li><li>Startdatum</li><li>Status</li><li>Kunde</li><li>Anfrage</li><li>Pilger/innen</li><li>Zimmer</li></ul>' },
            2: { pregunta: 'Was bedeutet der Status einer Buchung?', respuesta: '<p>Der Status zeigt die operative Phase an, zum Beispiel <strong>ANGEFRAGT</strong>, <strong>ANGEBOT ERSTELLT</strong> oder <strong>BESTÄTIGT</strong>.</p><p>Er wird außerdem mit der entsprechenden Farbe in der Tabelle und in der Detailansicht angezeigt.</p>' },
            3: { pregunta: 'Warum sehe ich einige Buchungen nicht?', respuesta: '<p>Die Liste wendet Regeln nach Herkunft des angemeldeten Benutzers an.</p><p>Als Agentur sehen Sie nur Buchungen Ihrer eigenen Herkunft.</p>' },
            4: { pregunta: 'Wie werden die Tabellenfilter angewendet?', respuesta: '<p>Jede Spalte verfügt über einen eigenen Filter.</p><p>Wenn Sie <strong>Enter</strong> drücken oder das Feld über das Symbol <strong>clear</strong> leeren, fragt die Liste den Endpunkt erneut mit den aktualisierten Parametern ab.</p>' },
            5: { pregunta: 'Wie funktioniert die Sortierung der Spalten?', respuesta: '<p>Sie können sortieren nach:</p><ul><li>Code</li><li>Agenturreferenz</li><li>Reisedaten</li><li>Status</li><li>Kunde</li><li>Anfrage</li><li>Pilger/innen</li><li>Zimmer</li></ul><p>Die Sortierung erfolgt auf dem Server.</p>' },
            6: { pregunta: 'Was kann ich tun, wenn ich ein Detail öffne und zur Liste zurückkehren möchte?', respuesta: '<p>Schließen Sie den Detaildialog, um weiter in der Tabelle zu arbeiten.</p><p>Filter, Seite und Sortierung der Liste bleiben erhalten.</p>' }
          },
          cuenta: {
            1: { pregunta: 'Wie melde ich mich sicher ab?', respuesta: '<p>Verwenden Sie die Option <strong>Abmelden</strong> im Seitenmenü.</p><p>Dadurch wird Ihre Sitzung beendet und Sie kehren zum Anmeldebildschirm zurück.</p>' },
            2: { pregunta: 'Was kann ich tun, wenn ich meine Zugangsdaten vergessen habe?', respuesta: '<p>Wenden Sie sich an die Verwaltung, um den Zugang wiederherzustellen.</p><p>Geben Sie Agentur, E-Mail-Adresse und Telefonnummer an.</p>' },
            3: { pregunta: 'Wo kann ich die Daten meiner Agentur prüfen oder aktualisieren?', respuesta: '<p>Im Agenturprofil können Sie Folgendes prüfen:</p><ul><li>Hauptinformationen</li><li>Logo</li><li>Weitere Daten, die mit Ihrem Konto verknüpft sind</li></ul>' },
            4: { pregunta: 'Warum kann meine Sitzung automatisch beendet werden?', respuesta: '<p>Aus Sicherheitsgründen kann Ihre Sitzung nach einer Zeit der Inaktivität ablaufen oder wenn das Token nicht mehr gültig ist.</p><p>In diesem Fall müssen Sie sich erneut anmelden.</p>' },
            5: { pregunta: 'An wen wende ich mich bei einem technischen Problem?', respuesta: '<p>Sie können an <strong>sistemas@rutasmeigas.com</strong> schreiben.</p><p>Geben Sie die Agentur, gegebenenfalls die betroffene Buchung und eine kurze Problembeschreibung an.</p>' }
          }
        }
      },
    },
  
    datos_de_reserva: 'Buchungsdaten',
    datos_personales: 'Persönliche Daten',
    resumen_reserva: 'Angebot gesendet!',
  
    preguntaPaso1: 'Wir benötigen einige Eckdaten um das Angebot Deines Jakobswegs für Dich zu erstellen:  Ankunftsdatum, Anzahl der Pilger/innen, Anzahl der Zimmer und Zimmertyp',
    datos_reserva: {
      fechas_seleccion: 'Startdatum(Anreisetag)',

      habitaciones_individuales: 'Einzelzimmer',
      habitaciones_dobles: 'Doppelzimmer (2_Einzelbetten)',
      habitaciones_dobles_matrimoniales: 'Doppelzimmer (1_Doppelbett)',
      habitaciones_triples: 'Dreibettzimmer',
      cantidad_de_peregrinos: 'Anzahl der Pilger/innen',

      titulo: 'Buchungsdaten:',
      fecha_inicio: 'Ankunftsdatum:',
      fecha_llegada: 'Abreisedatum:',
      habitaciones: 'Zimmer:',
      peregrinos: 'Pilger/innen:',
      comentarios: 'Erzähle uns jede zusätzliche Information.\nHaben Kinder? Sag uns ihre Alter.\nHaben Tiere? Sag uns, welches Tier es ist und sein Gewicht.',

      importe_reserva: 'Grundbetrag:',
      servicios_agregados: 'Zusatzleistungen:',
      importe_total: 'Gesamtbetrag:',
      comision_agencia: '15% Provision:',
      importe_neto_agencia: 'Netto Provision:',
      no_comisionable: '(Nicht kommissionierbar)',
      precio_por_peregrino: '€/Pilger',
    },

    servicios: {
      tab_servicios: 'Leistungen',
      incluidos_titulo: 'Enthaltene Leistungen:',
      incluidos_subtitulo: 'Wenn Du eine der enthaltenen Leistungen stornieren möchtest, kannst Du sie entfernen.',
      opcionales_titulo: 'Optionale Zusatzleistungen:',
      pendiente_de_tarifa: 'Ausstehend',
      subtitulo_desde: '(Von {tarifa}€)',
      subtitulo_por_persona: '({tarifa}€ x Pilger/innen)',
      subtitulo_por_persona_con_persona: '({tarifa}€ x {personas} Pilger/innen)',
      noche_extra_en: 'Zusatznacht in',
      traslado_extra: 'Zusatztransfer',
      servicio_extra: 'Zusatzleistung',
      ver_incluidos_boton: 'Inklusive Leistungen anzeigen',
    },

    siguientePaso1: 'Weiter',

    preguntaPaso2: 'Nun benötigen wir Deine Daten um Dir das Angebot so schnell wie möglich zu senden.',
    nombre: 'Vorname',
    apellidos: 'Nachname',
    telefono: 'Telefonnummer',
    email: 'E-Mail Adresse',

    politica_privacidad: 'Ich akzeptiere die ',
    politica_privacidad_texto_enlace: 'Datenschutzerklärung',
    politica_privacidad_enlace: 'https://rutasmeigas.com/de/datenschutz',

    acepta_novedades: 'Ich bin damit einverstanden, aktuelle Nachrichten zu erhalten.',

    recibir_presupuesto: 'Angebot anfordern',
    enviando_presupuesto: 'Angebot wird gesendet...',
    presupuesto_enviado: 'ANGEBOT GESDENDET!',

   
    datos_pasajeros: {
      titulo: "In Übereinstimmung mit der geltenden spanischen Gesetzgebung (Königliches Dekret 933/2021 vom 26. Oktober), das die Pflichten zur dokumentarischen Registrierung und Information von natürlichen oder juristischen Personen festlegt, die Beherbergungstätigkeiten ausüben (Reisebüros, Hotelbetriebe und Autovermietungen von Fahrzeugen). muss dem Innenministerium (Spanien) die folgenden Daten übermitteln.",
      subtitulo: 'Um Deine Buchung zu bearbeiten benötigen wir die kompletten Daten aller Pilger welche den Jakobsweg gehen. Bitte gib hier die Daten jedes einzelnen Pilgers im entsprechenden Formular an.<br>Es ist wichtig, dass die Daten so genau  und komplett wie möglich sind da wir diese nutzen um die Reise zu organisieren, Unterkünfte und andere Serviceleistungen zu reservieren.<br>Sobald alles komplett ausgefüllt ist, werden wir Deine Buchung bestätigen. Wenn Du Fragen hast oder etwas unklar ist , setze Dich bitte mit uns in Verbindung.',
      datos_peregrino: 'Reisender {index}',
      confirmar_datos: 'Daten bestätigen',
      guardar_datos: 'Daten der Reisenden speichern',


      nombre: 'Vorname',
      primer_apellido: 'Nachname',
      segundo_apellido: 'Zweiter Nachname',
      sexo: 'Geschlecht',
      sexo_opciones: {
        hombre: 'Männlich',
        mujer: 'Weiblich',
        no_decir: 'Keine Angabe',
      },
      fecha_nacimiento: 'Geburtsdatum',
      tipo_documento: 'Dokumenttyp',
      tipo_documento_opciones: {
        dni: 'DNI',
        nie: 'NIE',
        pasaporte: 'Reisepass',
      },
      numero_documento: 'Dokumentnummer',
      soporte_documento: 'Dokumentunterlage',
      telefono_fijo: 'Festnetztelefon',
      telefono_movil: 'Mobiltelefon',
      email: 'E-Mail Adresse',
      direccion: 'Adresse',
      poblacion: 'Ort',
      provincia: 'Provinz',
      codigo_postal: 'Postleitzahl',
      nacionalidad: 'Nationalität',
      parentesco: 'Beziehung',


      mensaje_final_success: 'Vielen Dank. Die Daten der Reisenden wurden erfolgreich gespeichert.',
      pagar: 'Bezahlen',
      mensaje_confirmacion_pasajero_y_pago: 'Deine Daten wurden erfolgreich gesendet. Wir informieren Dich, dass der Gesamtbetrag der Buchung {importe} € beträgt.<br>Du kannst jetzt einen Vorauszahlungsbetrag von 100 € für die Buchung leisten.',
      pago_realizado: 'Zahlung erfolgreich',
      pago_realizado_subtitulo: 'Vielen Dank für Ihre Vertrauen.<br>Wir werden uns schnellstmöglich um die Details Ihrer Buchung kümmern.',
      politica_privacidad: `Verantwortlicher für die Verarbeitung: RUTAS MEIGAS SL CIF: B15649270 Postanschrift: LUGAR DO BARCO 1, 15917 - PADRON (A CORUÑA) Telefon: 881019941 E-Mail: info@rutasmeigas.com
      Zweck der Verarbeitung Ihrer Daten: In Übereinstimmung mit den Bestimmungen der geltenden Gesetzgebung zum Schutz personenbezogener Daten, der Datenschutz-Grundverordnung 2016/679 (DSGVO) und des Organgesetzes 3/2018 vom 5. Dezember zum Schutz personenbezogener Daten und zur Gewährleistung digitaler Rechte (LOPDGDD) informieren wir Sie, dass der Zweck der Verarbeitung Ihrer Daten die Durchführung der Verwaltung Ihrer Reservierung ist.
      Legitimation: Artikel 6.1.a) der DSGVO. Die betroffene Person hat der Verarbeitung ihrer personenbezogenen Daten für einen oder mehrere bestimmte Zwecke zugestimmt. Artikel 6.1.b) der DSGVO. Verarbeitung, die für die Erfüllung eines Vertrags erforderlich ist, dessen Vertragspartei die betroffene Person ist, oder für die Durchführung vorvertraglicher Maßnahmen auf Anfrage der betroffenen Person. Artikel 6.1.c) der DSGVO: Die Verarbeitung ist für die Erfüllung einer gesetzlichen Verpflichtung erforderlich, der der Verantwortliche unterliegt: Königliches Dekret 933/2021 vom 26. Oktober zur Festlegung der Dokumentations- und Informationspflichten natürlicher oder juristischer Personen, die Beherbergungs- und Kraftfahrzeugvermietungstätigkeiten durchführen. Artikel 45 des Schengener Abkommens vom Juni 1985 • Organgesetz 4/2015 vom 30. März 2015 zum Schutz der Sicherheit der Bürger
      Aufbewahrung und Behandlung von Daten: Die bereitgestellten Daten werden so lange aufbewahrt, bis Sie ihre Löschung nicht beantragen, oder für die Zeit, die erforderlich ist, um gesetzlichen Verpflichtungen nachzukommen und möglichen Verbindlichkeiten nachzukommen, die sich aus der Erfüllung des Zwecks ergeben können, für den die Daten erhoben wurden. Ihre Daten werden an die verschiedenen Großhandelsunternehmen, mit denen das Unternehmen zusammenarbeitet, sowie gegebenenfalls an Fluggesellschaften, Hotels, Autovermietungen und/oder Reiseveranstalter übermittelt, um deren Dienstleistungen zu beauftragen oder Informationen zu Verfügbarkeit und Preisen anzufordern. Diese Anbieter können sich, je nach Land Ihres Reiseziels, in Ländern befinden, die kein vergleichbares Datenschutzniveau wie das in der EU haben, für die die Übermittlung zur Durchführung vertraglicher Maßnahmen erforderlich ist. Sie können auch an andere Unternehmen übermittelt werden, mit denen RUTAS MEIGAS SL zusammenarbeitet/kollaboriert, um die entsprechenden Verfahren und/oder Dienstleistungen durchzuführen. Andere Daten werden nicht an Dritte übermittelt, außer in Fällen, in denen eine gesetzliche Verpflichtung besteht. RUTAS MEIGAS SL erstellt auf der Grundlage der bereitgestellten Informationen keinerlei „Profile". Es werden keine automatisierten Entscheidungen auf der Grundlage von Profilen getroffen.
      Rechte: Sie können Ihre Rechte auf Zugriff, Berichtigung, Löschung, Widerspruch, Einschränkung der Verarbeitung, Datenübertragbarkeit und das Recht, keinen automatisierten Einzelentscheidungen in Bezug auf die verarbeiteten Daten zu unterliegen, gegenüber dem Verantwortlichen unter der Adresse RÚA LISBOA 16 BAJO IZDA – 15707 – SANTIAGO DE COMPOSTELA oder per E-Mail an info@rutasmeigas.com ausüben und eine Kopie Ihres Personalausweises oder eines gleichwertigen Dokuments beifügen. Falls Sie bei der Ausübung Ihrer Rechte nicht zufrieden sind, können Sie eine Beschwerde bei der zuständigen Datenschutzbehörde einreichen, der spanischen Datenschutzbehörde, deren Kontaktdaten unter https://sedeagpd.gob.es/sede-electronica-web/vistas/formNuevaReclamacion/reclamacion.jsf verfügbar sind.`
    },

    ir_al_camino: 'Mehr Informationen zum Jakobsweg',

    enviar_consulta: 'Senden',
    texto_consulta_agencia: 'Senden Sie Ihre Anfrage und wir werden uns schnellstmöglich um Ihre Anfrage kümmern.',
    consulta_enviada: 'Wir haben Ihre Anfrage erhalten, wir werden uns schnellstmöglich um Ihre Anfrage kümmern. Vielen Dank!',
 

  
  },
 
}
